import { render, staticRenderFns } from "./ReportLoads.vue?vue&type=template&id=17498e40&"
import script from "./ReportLoads.vue?vue&type=script&lang=js&"
export * from "./ReportLoads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports